import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { redirectToNotFound } from 'client/helpers/redirectTo';
import ApiRequest from 'client/helpers/apiRequest';
import { Tag } from 'client/types/tag';

import * as actions from './actions';

export const fetchTag = (slug: string): ThunkAction<Promise<any>, any, null, Action<string>> => dispatch => {
    dispatch(actions.fetchTagRequest(slug));

    return ApiRequest.get<Tag>(`/api/tags/${slug}`).then(
        response => dispatch(actions.fetchTagSuccess(response)),
        error => {
            dispatch(redirectToNotFound());
            dispatch(actions.fetchTagError(error));
        }
    );
};
